import React from 'react';
import { partners } from '../data/mock';

const PartnersSection = () => {
  return (
    <section id="partners" className="dark-container py-20">
      <div className="dark-content-container">
        <div className="text-center mb-16">
          <h2 className="display-large mb-6">Our Partners</h2>
          <p className="body-large max-w-4xl mx-auto">
            Collaborating with global technology leaders to deliver exceptional solutions
          </p>
        </div>

        {/* Hardware Partners */}
        <div className="mb-16">
          <h3 className="heading-1 mb-8 text-center">Hardware Partners</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {partners.hardware.map((partner, index) => (
              <div
                key={index}
                className="group p-6 rounded-lg dark-transition text-center"
                style={{ 
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}
              >
                <div className="mb-4 h-16 flex items-center justify-center">
                  <div 
                    className="w-full h-12 rounded flex items-center justify-center text-lg font-semibold"
                    style={{ 
                      background: 'rgba(0, 255, 209, 0.1)',
                      color: '#00FFD1'
                    }}
                  >
                    {partner.name}
                  </div>
                </div>
                <h4 className="heading-3 mb-2">{partner.name}</h4>
                <p className="body-small text-gray-400">{partner.category}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Software Partners */}
        <div className="mb-16">
          <h3 className="heading-1 mb-8 text-center">Software Partners</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {partners.software.map((partner, index) => (
              <div
                key={index}
                className="group p-8 rounded-lg dark-transition text-center"
                style={{ 
                  background: 'rgba(255, 255, 255, 0.05)',
                  border: '1px solid rgba(255, 255, 255, 0.1)'
                }}
              >
                <div className="mb-6 h-20 flex items-center justify-center">
                  <div 
                    className="w-full h-16 rounded flex items-center justify-center text-xl font-semibold"
                    style={{ 
                      background: 'rgba(0, 255, 209, 0.1)',
                      color: '#00FFD1'
                    }}
                  >
                    {partner.name}
                  </div>
                </div>
                <h4 className="heading-2 mb-3">{partner.name}</h4>
                <p className="body-medium text-gray-400">{partner.category}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Partnership CTA */}
        <div className="text-center">
          <div className="p-12 rounded-lg" style={{ 
            background: 'rgba(0, 255, 209, 0.05)',
            border: '1px solid rgba(0, 255, 209, 0.2)'
          }}>
            <h3 className="heading-1 mb-4">Become Our Partner</h3>
            <p className="body-large mb-8 max-w-2xl mx-auto">
              Join our ecosystem of technology leaders and help us deliver innovative solutions across the MENA region
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button className="btn-primary">
                <span>Partner With Us</span>
              </button>
              <button className="btn-secondary">
                <span>View Partnership Benefits</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;